
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cKyEk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $31838c163db1ffe8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $c26dffbb58ca4a48$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': "\u0410\u0433\u0440\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'extension.charts.aggregateDataDescription': "\u0415\u0441\u043B\u0438 \u0432 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0441\u0442\u0440\u043E\u043A\u0430\u0445 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u0441\u044F \u043E\u0434\u0438\u043D\u0430\u043A\u043E\u0432\u044B\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F, \u043E\u0431\u044A\u0435\u0434\u0438\u043D\u044F\u0442\u044C \u0438\u0445 \u0432 \u043E\u0434\u043D\u0443 \u0442\u043E\u0447\u043A\u0443 \u0434\u0430\u043D\u043D\u044B\u0445.",
    'extension.charts.category': "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F",
    'extension.charts.customizeTab': "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430",
    'extension.charts.dataMissing.details': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u0439\u0442\u0438 \u0438\u0441\u0445\u043E\u0434\u043D\u0443\u044E \u0442\u0430\u0431\u043B\u0438\u0446\u0443 \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435.",
    'extension.charts.dataMissing.title': "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
    'extension.charts.dataTab': "\u0414\u0430\u043D\u043D\u044B\u0435",
    'extension.charts.defaultColumnName': "\u0421\u0442\u043E\u043B\u0431\u0435\u0446 {0}",
    'extension.charts.defaultTitle': "\u0414\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F",
    'extension.charts.defaultYLabel': "\u041E\u0441\u044C \u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F",
    'extension.charts.extensionTitle': "\u0414\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430",
    'extension.charts.height': "\u0412\u044B\u0441\u043E\u0442\u0430 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F",
    'extension.charts.height.large': "\u0412\u044B\u0448\u0435",
    'extension.charts.height.medium': "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
    'extension.charts.height.small': "\u041D\u0438\u0436\u0435",
    'extension.charts.horizontal.orientation.label': "\u0413\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E",
    'extension.charts.insert.tooltip': "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0443",
    'extension.charts.legend': "\u041B\u0435\u0433\u0435\u043D\u0434\u0430",
    'extension.charts.legend.auto': "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438",
    'extension.charts.legend.bottom': "\u0412\u043D\u0438\u0437\u0443",
    'extension.charts.legend.left': "\u0421\u043B\u0435\u0432\u0430",
    'extension.charts.legend.position': "\u0420\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043B\u0435\u0433\u0435\u043D\u0434\u044B",
    'extension.charts.legend.right': "\u0421\u043F\u0440\u0430\u0432\u0430",
    'extension.charts.legend.show': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043B\u0435\u0433\u0435\u043D\u0434\u0443",
    'extension.charts.legend.top': "\u0412\u0432\u0435\u0440\u0445\u0443",
    'extension.charts.options.label': "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B",
    'extension.charts.options.tooltip': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B",
    'extension.charts.orientation.label': "\u041E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F",
    'extension.charts.seriesNames': "\u0420\u044F\u0434\u044B \u0434\u0430\u043D\u043D\u044B\u0445",
    'extension.charts.showPoints': "\u041E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0442\u043E\u0447\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445",
    'extension.charts.smoothLines': "\u0421\u0433\u043B\u0430\u0436\u0435\u043D\u043D\u044B\u0435 \u043B\u0438\u043D\u0438\u0438",
    'extension.charts.style': "\u0421\u0442\u0438\u043B\u044C",
    'extension.charts.title': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
    'extension.charts.type.bar': "\u0413\u0438\u0441\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u0430",
    'extension.charts.type.fieldDescription': "\u0422\u0438\u043F \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B",
    'extension.charts.type.line': "\u041B\u0438\u043D\u0435\u0439\u043D\u0430\u044F",
    'extension.charts.type.pie': "\u041A\u0440\u0443\u0433\u043E\u0432\u0430\u044F",
    'extension.charts.userTitle': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
    'extension.charts.vertical.orientation.label': "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E",
    'extension.charts.xAxis': "\u041E\u0441\u044C X",
    'extension.charts.xLabel': "\u041C\u0435\u0442\u043A\u0430 \u043E\u0441\u0438\xa0X",
    'extension.charts.yLabel': "\u041C\u0435\u0442\u043A\u0430 \u043E\u0441\u0438 Y"
};


var $31838c163db1ffe8$export$2e2bcd8739ae039 = (0, $c26dffbb58ca4a48$export$2e2bcd8739ae039);

});


//# sourceMappingURL=ru.fe0a183b.js.map
